import Vue from 'vue';
import Store from '@app/store';
import VueRouter from 'vue-router';
import RouterFunctions from '@app/router/functions';
import { EventTracking, EventType } from '@app/tracking';
Vue.use(VueRouter);
var initUri = window.PRELOADED_PAGE_DATA;
var initRoutes = [];
/*
 * Convert and push initial server-side rendered URI to router
 */
if (initUri) {
    var initRoute = RouterFunctions.makeRoute(initUri);
    initRoutes.push(initRoute);
    Store.MUTATIONS.setPageData(initRoute.path, initUri.uriable.parent);
}
/*
 * Main Vue Router Setup
 */
var router = new VueRouter({
    mode: 'history',
    routes: initRoutes,
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            RouterFunctions.scrollToAnchor(to.hash);
        }
        else if (savedPosition) {
            return savedPosition;
        }
        else {
            return { x: 0, y: 0 };
        }
    }
});
/**
 * Router Hooks before a route change
 */
router.beforeEach(function (to, from, next) {
    // Update page metadata
    if (to.meta) {
        RouterFunctions.updateMedadata(to);
    }
    if (Store.STATE.pageData[to.path]) {
        // Immediate navigation because page data already exists
        next();
        // Still make API call to update in the background (unless prefetched)
        if (typeof Store.STATE.pageData[to.path].__prefetched__ === 'undefined') {
            Store.ACTIONS.loadPageData(to.path);
        }
    }
    else if (RouterFunctions.routeExists(to.path)) {
        // Load page data and navigate on completion
        Store.MUTATIONS.setLoading(true);
        Store.ACTIONS.loadPageData(to.path).then(function () {
            next();
        });
    }
    else {
        next();
    }
});
/**
 * Router Hooks after a route change
 */
router.afterEach(function (to, from) {
    // Scroll to anchor if first pageload has anchor
    // Stop loading state after scrolling or immediately on normal route changes
    if (to.hash && from.name === null) {
        Vue.nextTick(function () {
            setTimeout(function () {
                RouterFunctions.scrollToAnchor(window.location.hash);
                Store.MUTATIONS.setLoading(false);
            }, Vue.pageTransitionDuration);
        });
    }
    else {
        Store.MUTATIONS.setLoading(false);
    }
    // Cancel further process if only hash changed
    if (to.path === from.path && to.hash != from.hash) {
        return;
    }
    // Dispatch a page view event for tracking services
    EventTracking.dispatch(EventType.PageView, {
        title: to.meta.title,
        path: to.path,
        isFirstPageLoad: window.IS_FIRST_PAGE_LOAD
    });
    // Unset first pageload flag
    if (window.IS_FIRST_PAGE_LOAD) {
        window.IS_FIRST_PAGE_LOAD = false;
    }
    // Remove SSR layout if exists
    Vue.nextTick(function () {
        var ssrLayout = document.getElementById('ssr');
        if (ssrLayout) {
            ssrLayout.parentNode.removeChild(ssrLayout);
        }
    });
});
export default router;
